import { Box } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { displayFont } from "../styles/theme";

export function Wordmark({ onClick }) {
  return (
    <Box
      component={RouterLink}
      to="/"
      onClick={onClick}
      aria-label="Groowv Electric Band, página inicial"
      sx={{
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "center",
        lineHeight: 1,
        color: "text.primary",
        textDecoration: "none",
      }}
    >
      <Box
        component="span"
        sx={{ fontFamily: displayFont, fontSize: { xs: 22, md: 26 }, letterSpacing: "0.14em" }}
      >
        GROOWV
      </Box>
      <Box
        component="span"
        sx={{ mt: 0.75, fontSize: 9, fontWeight: 600, letterSpacing: "0.42em", color: "primary.main" }}
      >
        ELECTRIC BAND
      </Box>
    </Box>
  );
}
